import React, { useState, useEffect } from 'react';
import { Upload, message, Button, Tooltip } from 'antd';
import { UploadOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import { baseImageUrl } from '@/global';



// 导入上传服务
import { uploadFile } from '@/services/file';


const CustomUpload = ({
  value,
  onChange,
  maxCount = 1,
  accept = 'image/*',
  listType = 'text',
  text = '',
  tooltip = '',
  ...props
}) => {
  const [loading, setLoading] = useState(false);
  const [fileList, setFileList] = useState([]);

  // 初始化文件列表
  useEffect(() => {
    if (value) {
      const initialFile = {
        uid: Date.now().toString(),
        name: value.split('/').pop(),
        status: 'done',
        url: value,
        thumbUrl: value.startsWith('http') ? value : baseImageUrl + value,
      };
      setFileList([initialFile]);
    } else {
      setFileList([]);
    }
  }, [value]);

  // 处理文件上传前的操作
  const beforeUpload = async (file) => {
    setLoading(true);

    try {
      const formData = new FormData();
      formData.append('files', file);
      // tag	image,video,audio
      formData.append('tag', accept.split('/')[0]);

      // 调用后端上传接口
      const response = await uploadFile(formData);
      console.log('上传响应:', response);
      if (response.code === 200 && response.data) {
        const fileUrl = response.data;
        const newFile = {
          uid: Date.now().toString(),
          name: file.name,
          status: 'done',
          url: fileUrl
        };
        const newFileList = [newFile];

        setFileList(newFileList);

        // 通知父组件文件上传成功
        if (onChange) {
          onChange(fileUrl);
        }

        message.success('文件上传成功');
      } else {
        message.error(response.message || '文件上传失败');
      }
    } catch (error) {
      console.error('文件上传失败:', error);
      message.error('文件上传失败，请稍后重试');
    } finally {
      setLoading(false);
    }

    // 阻止自动上传，因为我们已经在beforeUpload中处理了上传逻辑
    return false;
  };

  // 处理文件列表变化（包括删除文件）
  const handleChange = ({ fileList: newFileList }) => {

    // 只允许上传一个文件
    if (newFileList.length > maxCount) {
      message.warning(`最多只能上传${maxCount}个文件`);
      return;
    }

    setFileList(newFileList);

    // 如果文件列表为空，通知父组件删除文件
    if (newFileList.length === 0 && onChange) {
      onChange('');
    }
  };
  return (
    <div>
      <Upload
        {...props}
        fileList={fileList}
        beforeUpload={beforeUpload}
        onChange={handleChange}
        maxCount={maxCount}
        accept={accept}
        listType={listType}
        showUploadList={listType !== 'text' ? { showRemoveIcon: true } : {}}
      >
        {listType === 'picture-card' ? fileList.length >= maxCount ? null : (
          <div>
            <UploadOutlined />
            <div style={{ marginTop: 8 }}>上传</div>
          </div>
        ) : (
          <div>
              <Button style={{ marginRight: 8 }} icon={<UploadOutlined />} loading={loading}>上传文件</Button>
              {tooltip && <Tooltip title={tooltip}>
                <QuestionCircleOutlined />
              </Tooltip>}
          </div>
        )}
      </Upload>
      <div style={{ marginTop: 8, color: '#999' }}>
        {text || '支持PNG、JPG格式，建议尺寸160x90'}
      </div>
    </div>
  );
};

export default CustomUpload;
